import React, { useCallback, useRef, useState } from 'react';
import { useStoreActions, useStoreState } from '~/store';
import classes from './style.module.scss';
import UserAvatar from "~/user/UserAvatar";
import File from '~/app/modules/form/File';
import LightBox from '~/app/common/LightBox';
import { getShortName } from '~/user/helpers';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';
import useAccessControl from '~/app/hooks/useAccessControl';

export type UserDetailsComponent = React.FC

const UserDetails: UserDetailsComponent = () => {
    const user = useStoreState(state => state.user.data);
    const updating = useStoreState(state => state.user.updating);
    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const uploadProfileImage = useStoreActions(actions => actions.user.uploadProfileImage);

    const { checkPermission } = useAccessControl();
    const uploadProfileImagePermission = checkPermission(PERMISSION_GROUPS.uploadProfileImage);

    const inputFileRef = useRef<any>(null);
    const [flexBoxOpen, setFlexBoxOpen] = useState<boolean>(false);

    const toggleFlexBox = useCallback(() => {
        if (!netWorkStatus || flexBoxOpen === true) {
            setFlexBoxOpen(prev => !prev);
        }
    }, [netWorkStatus, flexBoxOpen]);

    const handleAvatarClick = useCallback(() => {
        if (uploadProfileImagePermission) inputFileRef.current?.triggerFileInputClick();
    }, [uploadProfileImagePermission]);

    const handleUploadProfileImage = useCallback((image, action) => {
        if (uploadProfileImagePermission) uploadProfileImage({ image, action });
    }, [uploadProfileImagePermission, uploadProfileImage]);

    const handleImageRemove = useCallback(() => {
        handleUploadProfileImage('', 'remove');
    }, [handleUploadProfileImage]);

    const handleImageUpload = useCallback(({ target: { value } }) => {
        handleUploadProfileImage(value, 'upload');
    }, [handleUploadProfileImage]);

    const { image, name, email } = user;

    return (
        <li className={classes['user']}>
            <UserAvatar className={classes['user-avatar']} onClick={toggleFlexBox} />
            <LightBox className={classes['light-box-image']}
                open={flexBoxOpen} onClose={toggleFlexBox}
                edit={uploadProfileImagePermission} onEdit={handleAvatarClick}
                remove={uploadProfileImagePermission} onRemove={handleImageRemove}
                loading={updating}
                imageUrl={image?.includes('user_default.png') ? null : image ?? null}
                avatarText={getShortName(name)}
            />
            <div className={classes['info']}>
                <span className={classes['name']}>{name}</span>
                <span className={classes['email']}>{email}</span>
            </div>
            <File
                ref={inputFileRef}
                name="images"
                onChange={handleImageUpload}
                maxFiles={1}
                preview={false}
                showInput={false}
                imageEdit={false}
                accept="image/*"
            />
        </li>
    );
};

export default UserDetails
